import { pushProductImpression, pushProductClick, pushPromoView, pushPromoClick } from "./utils";
const SEARCH_LIST = "Search recommendations";
const SEARCH_PROMO_VIEW = "promoView";

const handleSearchSuggestionsBannerImpression = () => {
    const searchBanners = document.querySelectorAll(".suggestions-advertising");
    const searchBannersImpression = [];
    searchBanners.forEach((item, index) => {
        const image = item.querySelector("img");
        const imageName = image?.dataset?.src.replace(/^.*[\\\/]/, "");// eslint-disable-line
        const bannerImpression = Object.assign({}, {
            "id" : "search-" + imageName,
            "name" : image?.alt,
            "creative" : imageName,
            "position" : index + 1
        });

        if (image) {
            image.addEventListener("click", () => {
                pushPromoClick([bannerImpression]);
            });
        }

        searchBannersImpression.push(bannerImpression);
    });
    pushPromoView(searchBannersImpression, SEARCH_PROMO_VIEW);
};

const handleSearchSuggestionsProductImpressions = () => {
    const searchProducts = document.querySelectorAll(".suggestion-product-item");
    const searchProductsImpressions = [];
    searchProducts.forEach((item, index) => {
        let searchProductImpression = Object.assign(JSON.parse(item?.dataset?.productTileImpression), {
            "position" : index + 1
        });

        item.querySelector(".suggestion-product-image").addEventListener("click", () => {
            pushProductClick([searchProductImpression], SEARCH_LIST);
        });

        item.querySelector(".suggestion-product-name").addEventListener("click", () => {
            pushProductClick([searchProductImpression], SEARCH_LIST);
        });

        item.querySelector(".suggestion-product-add").addEventListener("click", () => {
            pushProductClick([searchProductImpression], SEARCH_LIST);
        });

        searchProductImpression = Object.assign(searchProductImpression, {
            "list" : SEARCH_LIST
        });

        searchProductsImpressions.push(searchProductImpression);
    });

    pushProductImpression(searchProductsImpressions);
};

const initDataLayerEvents = () => {
    document.addEventListener("dataLayer.showSuggestions", () => {
        handleSearchSuggestionsBannerImpression();
        handleSearchSuggestionsProductImpressions();
    });
};

module.exports = {
    initDataLayerEvents : initDataLayerEvents
};
